module.exports = __webpack_public_path__ + "static/img/RAPW800_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPW800_1.png
// module id = pP+w
// module chunks = 0